// Plik: frontend/src/services/api.js
import axios from 'axios';

// Tworzenie instancji Axios
export const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Usługa API dla rejestracji
export const registrationService = {
  // Pobierz dostępne terminy
  getSlots: async () => {
    try {
      const response = await api.get('/registration/slots');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Nie udało się pobrać terminów'
      };
    }
  },
  
  // Zarejestruj uczestnika
  registerParticipant: async (participantData) => {
    try {
      const response = await api.post('/registration/register', participantData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Nie udało się zarejestrować'
      };
    }
  }
};

// Usługa API dla administratora
export const adminService = {
  // Pobierz wszystkie terminy (dla admina)
  getSlots: async () => {
    try {
      const response = await api.get('/admin/slots');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Nie udało się pobrać terminów'
      };
    }
  },
  
  // Dodaj nowy termin
  addSlot: async (slotData) => {
    try {
      const response = await api.post('/admin/slots', slotData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Nie udało się dodać terminu'
      };
    }
  },
  
  // Aktualizuj termin
  updateSlot: async (id, slotData) => {
    try {
      const response = await api.put(`/admin/slots/${id}`, slotData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Nie udało się zaktualizować terminu'
      };
    }
  },
  
  // Usuń termin
  deleteSlot: async (id) => {
    try {
      const response = await api.delete(`/admin/slots/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Nie udało się usunąć terminu'
      };
    }
  },
  
  // Pobierz uczestników
  getParticipants: async (filters = {}) => {
    try {
      const response = await api.get('/admin/participants', { params: filters });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Nie udało się pobrać uczestników'
      };
    }
  },
  
  // Aktualizuj uczestnika
  updateParticipant: async (id, participantData) => {
    try {
      const response = await api.put(`/admin/participants/${id}`, participantData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Nie udało się zaktualizować uczestnika'
      };
    }
  },
  
  // Usuń uczestnika
  deleteParticipant: async (id) => {
    try {
      const response = await api.delete(`/admin/participants/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Nie udało się usunąć uczestnika'
      };
    }
  },
  
  // Pobierz statystyki
  getStatistics: async () => {
    try {
      const response = await api.get('/admin/statistics');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Nie udało się pobrać statystyk'
      };
    }
  },
  
  // Eksportuj dane do CSV
  exportData: async (date) => {
    try {
      // Utwórz link do pobrania pliku
      const params = date ? `?date=${date}` : '';
      const downloadUrl = `${api.defaults.baseURL}/admin/export${params}`;
      
      // Otwórz link w nowym oknie lub pobierz plik
      window.open(downloadUrl, '_blank');
      
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: 'Nie udało się pobrać pliku CSV'
      };
    }
  }
};

// Usługa API dla ustawień strony
export const settingsService = {
  // Pobierz wszystkie ustawienia (publiczny)
  getSettings: async () => {
    try {
      const response = await api.get('/settings');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Nie udało się pobrać ustawień'
      };
    }
  },
  
  // Aktualizuj ustawienia (wymaga autoryzacji)
  updateSettings: async (settings) => {
    try {
      const response = await api.put('/settings', settings);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Nie udało się zapisać ustawień'
      };
    }
  },
  
  // Upload regulaminu (wymaga autoryzacji)
  uploadRegulamin: async (file) => {
    try {
      const formData = new FormData();
      formData.append('regulamin', file);
      
      const response = await api.post('/settings/upload-regulamin', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Nie udało się przesłać regulaminu'
      };
    }
  },
  
  // Usuń regulamin (wymaga autoryzacji)
  deleteRegulamin: async () => {
    try {
      const response = await api.delete('/settings/regulamin');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Nie udało się usunąć regulaminu'
      };
    }
  }
};